import { render, staticRenderFns } from "./crear-colegios.vue?vue&type=template&id=2d375f48"
import script from "./crear-colegios.vue?vue&type=script&lang=js"
export * from "./crear-colegios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports